<template>
  <div class="settings">
    <div class="settings md-elevation-4">
      <div class="md-layout">
        <div class="md-layout-item p10">
          <h1>Change password</h1>
          <h2 v-if="updated">Password was updated.</h2>
          <div class="md-layout">
            <div class="md-layout-item p10">
              <md-field :class="messageClassOldPass">
                <label>Old password</label>
                <md-input type="password" v-model="old" required></md-input>
                <span class="md-error">Password not match</span>
              </md-field>
            </div>
          </div>
          <div class="md-layout">
            <div class="md-layout-item p10">
              <md-field :class="messageClassNewPass">
                <label>New password</label>
                <md-input type="password" v-model="password" required></md-input>
                <span class="md-error">Please fill password</span>
              </md-field>
            </div>
          </div>
          <div class="md-layout">
            <div class="md-layout-item p10">
              <md-field :class="messageClassRepeatPass">
                <label>Repeat new password</label>
                <md-input type="password" v-model="repeat" required></md-input>
                <span class="md-error">Password not match</span>
              </md-field>
            </div>
          </div>
          <div class="md-layout">
            <div class="md-layout-item p10">
              <md-button class="md-accent md-raised" @click="onSave">Save</md-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ResetPassword from '../graphql/ResetPassword.gql'

export default {
  name: 'Settings',
  props: ['user', 'isAdmin'],
  computed: {
    messageClassOldPass() {
      return {
        'md-invalid': this.validate && (this.old == "" || this.oldPassErr)
      }
    },
    messageClassNewPass() {
      return {
        'md-invalid': this.validate && this.password == ""
      }
    },
    messageClassRepeatPass() {
      return {
        'md-invalid': this.validate && this.repeat != this.password
      }
    },
    isValid() {
      return this.validate &&
        this.old != "" &&
        this.password != "" &&
        this.repeat == this.password

    }
  },
  data(){
    return {
      old: "",
      password: "",
      repeat: "",
      oldPassErr: false,
      updated: false,
      validate: false
    }

  },
  methods: {
    onSave(){

      this.oldPassErr = false
      this.validate = true
      if(!this.isValid) {
        return
      }
      this.$apollo.mutate({
        mutation: ResetPassword,
        variables: {
          old: this.old,
          password: this.password
        }
      }).then(() => {
        this.validate = false
        this.old = "";
        this.password = "";
        this.repeat = "";
        this.updated = true;
      }).catch((data) => {

        if (data.graphQLErrors && data.graphQLErrors.length){
          if (data.graphQLErrors[0].extensions.code == "OLD_PASSWORD_MATCH") {
            this.oldPassErr = true
            this.updated = false;
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
h2 {
  color: green;
}
.settings {
  background-color: #fff;
}
</style>